import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { CarStatus } from "../history/historyApi";
import { Phone } from "../selectOptions/selectOptionsApi";
import * as customerCareApi from "../../api/customerCare/customerCareApi"
import { ICustomerTypes } from "../selectOption/selectOptionsApi";
import { LogHistoryType } from "../../services/data";
//Thông tin khách hàng
export interface relationshipProp {
  name: string,
  hobby: number[],
  relationship: number | null
}

export interface ICareStaff {
  fullname: string,
  id: number,
}
export interface IPermissionMenu {
  groupPermissionId: number
  view: boolean
  edit: boolean
  delete: boolean
}

export interface IAddress {
  provinceId: number
  districtId: number
  address: string
  type: number
}
export interface ICustomerDetail {
  id: number
  image: string
  userName: any
  CCCD: string
  birthday: string
  gender: number
  email: string
  address: string
  profession: string
  statusMarital: number
  hobby: Item[]
  relatives: Rela[]
  rank: Rank
  classifys: Item[]
  history: History[]
  carCare: CarCare[]
  phone: Phone2[]
}

export interface ICustomerDetail_V2 {
  id: number
  userName: string
  CCCD: ICCCD[]
  image?: string
  birthday: string
  gender: number
  email: string
  address: string
  statusMarital: number
  profession: Item
  hobby: Item[]
  relatives: Item[]
  groupCustomer: Item[]
  customerType: ICustomerTypes[]
  phone: IPhone[]
  province: Item
  district: Item,
  businessCheck?: number
  businessField?: Item
  admin: string
  taxCode?: string
  foundingDate?: string
  delf?: number
  totalCareCustomer: number
  description: string
  unitTitle: string
  unitCode: string
  code?: string
  careStaff: string
  dateCreate: string,
  pointfSale: string,
  informationChannel: string,
  sourceCustomer: number[],
  carLine?: Item[],
  contactMethod?: Item[]
  type: number
}

export interface ICustomerDetail_V4 {
  invoiceSaleDocDate: string
  birthdayMessage: string
  serviceRemindMessage: string
  serviceRemindList: string[]
  id: number
  userName: IUserName[]
  rank: {
    rankId: any
    title: any
    icon: any
    releaseDate: string
    expirationDate: string
    listcarePolicieId: Array<{
      id: number
    }>
  }
  CCCD: ICCCD[]
  image?: string
  birthday: string
  gender: number
  email: { email: string }[]
  address: IAddress[]
  statusMarital: number
  profession: Item
  hobby: Item[]
  relatives: Item[]
  groupCustomer: Item[]
  customerType: ICustomerTypes[]
  phone: IPhone[]
  province: Item
  district: Item,
  businessCheck: 0 | 1
  businessField?: Item
  admin: string
  taxCode?: string
  foundingDate?: string
  delf?: number
  totalCareCustomer: number
  description: string
  unitTitle: string
  unitCode: string
  code?: string
  careStaff: string
  dateCreate: string,
  pointfSale: string,
  informationChannel: string,
  sourceCustomer: number[],
  carLine?: Item[],
  contactMethod?: Item[]
  type: number,
  relativeId?: number,
  relativeTitle?: string,
  identityType?: number
  age?: number

  //mơi
  originalId?: string
  permissions?: Permissions

  totalOwnerVehicles?: number
  totalVehiclePassenger?: number
  totalVehicleBus?: number
  totalServiceAmount?: number
  totalPurchaseAmount?: number
  totalAmount?: number
  totalPurchaseInvoices?: number
  totalServiceInvoices?: number

}

export interface Permissions {
  username: boolean
  phone: boolean
  gender: boolean
  statusMarital: boolean
  code: boolean
  invoiceSaleDocDate: boolean
  totalOwnerVehicles: boolean
  totalVehiclePassenger: boolean
  totalVehicleBus: boolean
  totalServiceAmount: boolean
  totalPurchaseAmount: boolean
  totalAmount: boolean
  totalServiceInvoices: boolean
  totalPurchaseInvoices: boolean
  rank: boolean
  email: boolean
  age: boolean
  customerType: boolean
}


export interface Item {
  id: number
  title: string
}

export interface Rela {
  name: string
  relationship: Item
  hobby: Item[]
}


export interface Rank {
  icon: string
  title: string
}

export interface History {
  historyId: number
  bks: string
  categoryCar: string
  car: string
  imageCar?: string
  imageCategoryCar?: string
  code: string
  purchaseDate: string
  licensePlates: string
  version: string
  carLine: string
  segmentsVehicle: string
}

export interface CarCare {
  categoryCar: string
  car: string
  imageCar?: string
  imageCategoryCar?: string
  version: string
  carLine: string
  segmentsVehicle: string
}

//list
export interface DataTypeCustomer {
  key: any;
  action: string;
  stt: number;
  name: string;
  cccd: string;
  birthday: string;
  gender: number;
  phone: string;
  email: string;
  interestedCar: string;

  province: string,
  profession: string,
  address: string,
  source: any,
  rankTitle: string,
  statusMarital: string,
}
export interface ICustomer {
  id: number
  name: string
  CCCD: string
  phone: string
  birthday: string
  gender: number
  profession: string
  statusMarital: number
  address: string
  email: string
  province: string
  interestedCar: string
}

export interface ICustomer_V2 {
  id: number
  name: string
  CCCD?: string
  phone: string
  birthday: string
  gender: number
  statusMarital: number
  address?: string
  email: string
  province?: Item
  rankTitle?: Item
  taxCode?: string
  profession?: Item
  code?: string
  unitTitle?: string
  permissionMenu: IPermissionMenu
}

export interface IDetailCustomer {
  id: number
  userName: string
  image: string
  CCCD: any
  birthday: string
  gender: number
  email: string
  address: string
  profession: string
  statusMarital: number
  hobby: string[]
  relatives: Rela[]
  classifys: string[]
  history: any[]
  carCare: CarCare[]
  rank: any
  groupCustomer: string[]
  phone: Phone[]
  agent: string
}

export interface ICustomerDetail2 {
  id: number
  userName: string
  image: string
  CCCD: string
  birthday: string
  gender: number
  email: string
  address: string
  profession: string
  statusMarital: number
  hobby: Item[]
  relatives: Rela2[]
  classifys: Item[]
  history: History2[]
  carCare: CarCare2[]
  rank: any
  groupCustomer: Item[]
  phone: Phone2[]
  agent: Item
  province: Item
}

export interface ICustomerDetail_V3 {
  statusMarital: number
  isDelete: number
  id: number
  username: string
  code: string
  image: any
  identityType: number
  type: number
  status: number
  delf: number
  adminId: number
  businessCheck: number
  relativeId: any
  unitId: number
  updatedAt: string
  gender: number
  professionId: any
}

export interface Phone2 {
  phone: string
  type: number
}

export interface CarCare2 {
  id: number
  categoryCar: string
  imageCategoryCar: string
  car: string
  imageCar: string
  version: string
  carLine: string
  segmentsVehicle: string
}
export interface History2 {
  idCar?: number
  categoryCar?: string
  imageCategoryCar: string
  car?: string
  code: string
  bks?: string
  imageCar: string
  purchaseDate: string
  licensePlates?: string
  version: string
  carLine: string
  segmentsVehicle: string
}
export interface Rela2 {
  name: string
  relationship: Item
  hobby: Item[]
}

export interface IPhone {
  phone: string,
  categoryPhoneId: number
}

export interface ICCCD {
  identityType: number,
  isPrimary: number,
  name: string
}

export interface IUserName {
  isPrimary: number,
  username: string
}

//Quan hệ
export interface IRelationship {
  id: number
  name: string
  email?: string
  phone: string
  address?: string
  birthday: string
  gender: number
  relative: Item
  province: Item
  profession: Item
  district: Item
  CCCD: string
}
// thông tin xe đang sử dụng
export interface IHistoryCarInUseDetail {
  numberContract: string,
  yearManufacture: string,
  VIN: string,
  colorCode: string,
  codeCar: string,
  colorCar: string,
  colorInterior: string,
  BKS: string,
  TVBH: string,
  datePurchaseCar: string,
  datePickUpCar: string,
  carLines: string,
  categoryCar: string,
  categoryCarImage: string,
  carName: string,
  carImage: string,
  typeCar: string,
  agent: string,
  type: CarStatus
}
export interface data {
  id: number,
  title: string,
  image: string
}
// thông tin xe quan tâm
export interface ICarInterested {
  yearManufacture: string
  categoryCar: data
  car: data
  carLine: { id: number, title: string }
  typeVehicle: { id: number, title: string }
  colorCar: string

}

export interface ITabCounts {
  chamSoc: number
  banHang: number
  hoTroKhieuNai: number
  chamSocKH: number
  khaoSat: number
}

export interface IPhoneFilterListPhoneCustomer {
  phone: string
}

//lịch sử cập nhật kh
export interface ICustomerUpdateHistory {
  taskId?: string
  timestamp: string
  admin: AdminCustomerUpdateHistory
  detail: DetailCustomerUpdateHistory[]
}

export interface AdminCustomerUpdateHistory {
  fullname?: string
  img?: string
  email?: string
  code?: string
}

export interface DetailCustomerUpdateHistory {
  id: number
  action: string
  descriptions: string[]
}

export const getFilterListPhoneCustomer = async (
  permittedCategoryCarIds: number[],
  limit?: number, pageNumber?: number, search?: string, unitId?: number
) => {
  const path = "apiChild/listPhoneCustomer"
  const params = {
    permittedCategoryCarIds,
    limit, pageNumber, search, unitId
  }
  const result: ResponseSuccessTotal<IPhoneFilterListPhoneCustomer[]> = await axiosClient.get(
    path, { params }
  );
  return result;
}


export const getInforCarInUseHistory = async (id?: number) => {
  const path = "HistoryCarCustomer/infoHistoryCustomer"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<IHistoryCarInUseDetail> = await axiosClient.get(
    path, { params }
  );
  return result;
}

export const getInforCarInterested = async (id?: number) => {
  const path = "interestedCarCustomer/infoInterestedCar"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<ICarInterested> = await axiosClient.get(
    path, { params }
  );
  return result;
}
// thêm xe đang sử dụng
export const addCarInUse = async (
  type: CarStatus,
  customerId?: number, numberContract?: string, agentId?: number, carId?: number, categoryCarId?: number, carLinesId?: number, carTypeId?: number, yearManufacture?: string,
  colorCode?: string, colorCar?: string, colorInterior?: string, BKS?: string, VIN?: string, TVBH?: string, vehicleCondition?: number, datePurchaseCar?: string, datePickUpCar?: string
) => {
  const path = "HistoryCarCustomer/addHistoryCarCustomer"
  const params = {
    type,
    customerId, numberContract, agentId, carId, categoryCarId, carLinesId, carTypeId, yearManufacture, colorCode, colorCar, colorInterior, BKS, VIN, TVBH, vehicleCondition, datePurchaseCar, datePickUpCar
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    path, params
  );
  return result;
}
// thêm xe quan tâm
export const addCarInterested = async (
  customerId?: number, carId?: number, categoryCarId?: number, carLinesId?: number, typeVehicleCarId?: number, yearManufacture?: string,
) => {
  const path = "interestedCarCustomer/addinterestedCarCustomer"
  const params = {
    customerId, carId, categoryCarId, carLinesId, typeVehicleCarId, yearManufacture
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    path, params
  );
  return result;
}
export const getListCustomer = async (
  permittedCategoryCarIds: number[],
  limit?: number, pageNumber?: number, search?: string, filterCustomerId?: number,
  ageMin?: number, ageMax?: number, gender?: number[], listArea?: number[], listProvince?: number[],
  listProfession?: number[], listRank?: number[], statusMarital?: number[], listHobby?: number[],
  //listCategoryCar
  priceMin?: number, priceMax?: number,
) => {
  const path = "customer/listCustomer"
  const params = {
    permittedCategoryCarIds,
    limit, pageNumber
  }
  const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListCustomer_V2 = async (
  permittedCategoryCarIds: number[],
  limit?: number, pageNumber?: number, search?: string, filterCustomerId?: number,
  ageMin?: number, ageMax?: number, gender?: Number[], listArea?: number[], listProvince?: number[],
  listProfession?: number[], listRank?: number[], statusMarital?: number[], listHobby?: number[],
  listCategoryCar?: number[], priceMin?: number, priceMax?: number, numberOwnedCar?: number, ownershipPeriodCar?: number,
  listUnit?: number[], listGroupCustomer?: number[], listSourceCustomer?: Number[],
  professionSelectAll?: number, hobbySelectAll?: number, unitSelectAll?: number,
  groupCustomerSelectAll?: number, listPhone?: string[], businessCheck?: number[], unitId?: number



) => {
  const path = "customer/listCustomer"
  const params = {
    permittedCategoryCarIds,
    limit, pageNumber,
    search, filterCustomerId,
    ageMin, ageMax, gender, listArea, listProvince,
    listProfession, listRank, statusMarital, listHobby,
    listCategoryCar, priceMin, priceMax, numberOwnedCar, ownershipPeriodCar,
    listUnit, listGroupCustomer, listSourceCustomer,
    professionSelectAll, hobbySelectAll, unitSelectAll,
    groupCustomerSelectAll, listPhone, businessCheck, unitId

  }
  const result: ResponseSuccessTotal<ICustomer_V2[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thông tin khách hàng
export const getInfoCustomer = async (id: number) => {
  const path = "customer/infoCustomer"
  const params = {
    id
  }
  const result: ResponseSuccess<ICustomerDetail_V4> = await axiosClient.get(path, { params });
  return result;
};

export const getTabCounts = async (id: number) => {
  const path = "customer/tabCounts"
  const params = {
    id
  }
  const result: ResponseSuccess<ITabCounts> = await axiosClient.get(path, { params });
  return result;
};


// add kh
export const addCustomer = async (
  username: string,
  gender: number,
  statusMarital: number,
  profession: string,
  phone: Array<{ phone: string, type: number }>,
  birthday: string,
  email: string,
  provinceId: number | null,
  address: string,
  image: File | null,
  groupCustomerId: number[],
  tagsId: number[],
  hobbyId: number[],
  carId: number[],
  relationshipList: Array<relationshipProp>,

) => {
  const url = `customer/addCustomer`;
  const params = {
    username,
    gender,
    statusMarital,
    profession,
    phone,
    birthday,
    email,
    provinceId,
    address,
    image,
    groupCustomerId,
    tagsId,
    hobbyId,
    carId,
    relationshipList,
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}

// add kh
export const addCustomer_V2 = async (
  businessCheck: number,
  username: string,
  phone: IPhone,
  CCCD?: string,
  identityType?: number,
  gender?: number,
  statusMarital?: number,
  listTypes?: number[],
  professionId?: number,
  birthday?: string,
  email?: string,
  provinceId?: number,
  districtId?: number,
  address?: string,
  image?: File | null,
  groupCustomerId?: number[],
  hobbyId?: number[],
  isRelative?: number,
  customerId?: number,
  relativeId?: number,
  description?: string,
  taxCode?: string,
  foundingDate?: string,
  businessFieldId?: number,
  unitTempId?: number
) => {
  const url = `customer/addCustomer`;
  const params = {
    businessCheck,
    username,
    phone,
    CCCD,
    identityType,
    gender,
    statusMarital,
    listTypes,
    professionId,
    birthday,
    email,
    provinceId,
    districtId,
    address,
    image,
    groupCustomerId,
    hobbyId,
    isRelative,
    customerId,
    relativeId,
    description,
    taxCode,
    foundingDate,
    businessFieldId,
    unitTempId
  }
  const result: ResponseSuccess<ICustomerDetail_V3> = await axiosClient.post(
    url, params
  );
  return result;
}



// update

export const updateCustomer = async (
  id: number,
  username: string,
  gender: number,
  statusMarital: number,
  profession: string,
  phone: Array<{ phone: string, type: number }>,
  image: File | null,
  birthday: string,
  provinceId: number | null,
  email: string,
  address: string,
  groupCustomerId: number[],
  tagsId: number[],
  hobbyId: number[],
  carId: number[],
  relationshipList: Array<relationshipProp>

) => {
  const url = `customer/editCustomer`;
  const params = {
    id,
    username,
    gender,
    statusMarital,
    profession,
    phone,
    image,
    birthday,
    provinceId,
    email,
    address,
    groupCustomerId,
    tagsId,
    hobbyId,
    carId,
    relationshipList
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}

// up kh
export const updateCustomer_V2 = async (
  id: number, username: string,
  email: string, phone: IPhone[], provinceId: number, districtId: number, groupCustomerId: number[], hobbyId: number[], gender?: number, statusMarital?: number, professionId?: number, birthday?: string, CCCD?: string,
  address?: string, image?: File | null, taxCode?: string, foundingDate?: string, businessFieldId?: number, description?: string
) => {
  const url = `customer/editCustomer`;
  const params = {
    id,
    username,
    CCCD,
    gender,
    statusMarital,
    professionId,
    phone,
    birthday,
    email,
    provinceId,
    districtId,
    address,
    image,
    groupCustomerId,
    hobbyId,
    taxCode,
    foundingDate,
    businessFieldId,
    description
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}


//info
// export const getDetailCustomer = async (id: number) => {
//   const path = "customer/infoCustomer"
//   const params = {
//     id
//   }
//   const result: ResponseSuccess<ICustomerDetail2> = await axiosClient.get(path, { params });
//   return result;
// };

export const getListCustomerUpdateHistory = async (
  id: number,
  limit?: number, pageNumber?: number, search?: string, adminId?: number,
  moduleId?: LogHistoryType
) => {
  const path = "/relatives/listCustomerUpdateHistory"
  const params = {
    id,
    limit, pageNumber, search, adminId,
    moduleId
  }
  const result: ResponseSuccessTotal<ICustomerUpdateHistory[]> = await axiosClient.get(path, { params });
  return result;
};

//Xóa khách hàng
export const deleteCustomer = async (
  id: number | number[] | undefined
) => {
  const path = "customer/deleteCustomer"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    path, { params }
  );
  return result;
};
//Xóa xe đang sử dụng
export const deleteCarInUse = async (
  id: number
) => {
  const path = "HistoryCarCustomer/deleteListHistoryCustomer"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    path, { params }
  );
  return result;
};
//Xóa xe quan tâm
export const deleteCarInterested = async (
  id: number
) => {
  const path = "interestedCarCustomer/deleteInterestedCar"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    path, { params }
  );
  return result;
};
export interface ResponseSuccessV2 {
  status?: boolean;
  // statusError?: string;
  dataError: IDataErrorCustomer[];
  message?: string;
  newlyCreatedRecords: number
  totalRecords: number
  unimportedRecords: number
}
export interface IDataErrorCustomer {
  nameCustomer: string
  CCCDCustomer: string
  birthdayCustomer: string
  genderRelative: string
  phoneCustomer: string
  emailCustomer: string
  messageError?: string
}

export interface ResponseSuccessDataError {
  status: boolean;
  dataError: IDataError[];
  message: string;
  newlyCreatedRecords: number
  totalRecords: number
  unimportedRecords: number
}
export interface IDataError {
  row: {
    titleCarLines: string
    titleTypeVehicle: any
    titleCategoryCar: string
    titleVehicleGroup: string
    titleVehicleModel: string
    titleCar: string
    code: string
    titleSegmentsVehicle: any
    codeB7: string
    codeCustomer?: string
    dateReception?: string
    typeSupport?: string
    note?: string
    adminName?: string
    supportChanel?: string
    sourceCustomer?: string
  }
  reason: string
  rowIndex: number
}
export const uploadFile = async (
  file: File,
) => {
  const url = `customer/excel`;
  const params = {
    file
  }
  const result: ResponseSuccessV2 = await axiosClient.post(
    url, params
  );
  return result;
}
// chăm sóc phản hồi
export const uploadFileCareFeedBack = async (
  file: File,
) => {
  const url = `careCustomer/excel`;
  const params = {
    file
  }
  const result: ResponseSuccessDataError = await axiosClient.post(
    url, params
  );
  return result;
}
//xe
export const uploadFileCar = async (
  file: File,
) => {
  const url = `car/importExcel`;
  const params = {
    file
  }
  const result: ResponseSuccessDataError = await axiosClient.post(
    url, params
  );
  return result;
}
// chủng loại
export const uploadFileVehicle = async (
  file: File,
) => {
  const url = `typeVehicle/importExcel`;
  const params = {
    file
  }
  const result: ResponseSuccessDataError = await axiosClient.post(
    url, params
  );
  return result;
}
// thương hiệu
export const uploadFileCategory = async (
  file: File,
) => {
  const url = `categoryCar/importExcel`;
  const params = {
    file
  }
  const result: ResponseSuccessDataError = await axiosClient.post(
    url, params
  );
  return result;
}
// dòng xe
export const uploadFileCarLine = async (
  file: File,
) => {
  const url = `carLines/importExcel`;
  const params = {
    file
  }
  const result: ResponseSuccessDataError = await axiosClient.post(
    url, params
  );
  return result;
}
//màu xe
export const uploadFileColorCar = async (
  file: File,
) => {
  const url = `car/excelCarColor`;
  const params = {
    file
  }
  const result: ResponseSuccessDataError = await axiosClient.post(
    url, params
  );
  return result;
}
